import axios from '../../utils/axiosConfig';
import { Contexture } from './Contexture';

const BASE_URL = `${process.env.REACT_APP_LAMBDA_API_URL}/contexture/social/msteams`;

export class MSTeams {
  static async authorize(params) {
    try {
      const response = await axios.get(`${BASE_URL}/authorize`, {
        headers: Contexture.getHeaders(),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async deauthorize(params) {
    try {
      const response = await axios.get(`${BASE_URL}/deauthorize`, {
        headers: Contexture.getHeaders(),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async isMSTeamsAvailable(params) {
    try {
      const response = await axios.get(`${BASE_URL}/is_ms_teams_available`, {
        headers: Contexture.getHeaders(),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async getTeams(params) {
    try {
      const response = await axios.get(`${BASE_URL}/teams`, {
        headers: Contexture.getHeaders(),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async getChannels(params) {
    try {
      const response = await axios.get(`${BASE_URL}/channels`, {
        headers: Contexture.getHeaders(),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async createOrUpdateChannels(data, params) {
    try {
      const response = await axios.post(`${BASE_URL}/channels`, data, {
        headers: {
          ...Contexture.getHeaders(),
          'Content-Type': 'application/json',
        },
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async createOrUpdateTeam(data, params) {
    try {
      const response = await axios.post(`${BASE_URL}/team`, data, {
        headers: {
          ...Contexture.getHeaders(),
          'Content-Type': 'application/json',
        },
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async share(params) {
    try {
      const response = await axios.get(`${BASE_URL}/share`, {
        headers: Contexture.getHeaders(),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }
}
